module.exports = __webpack_public_path__ + "static/media/meet-blueprint-23-24.5dd35393.png";